export default __webpack_public_path__ + "static/media/me2.dc5cfb2b.png";